import { authService } from "../shared";
import axios from "axios";
import { message as messageAlert } from "antd";

export const getAdminOrSubAdmins = async (token) => {
  const uri = "/admin/api/v1/customers/getAdminOrSubAdmins";
  const resp = await axios.get(authService + uri, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const getCustomers = async (token, data) => {
  let uri = `/admin/api/v1/customers/getAllCustomers?limit=20`;

  const resp = await axios.get(authService + uri, {
    params: { ...data },
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const getFranchiseRequest = async (token, data) => {
  let uri = `/api/v1/franchise`;

  const resp = await axios.get(authService + uri, {
    params: { ...data },
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};


// Unified dashboard stats: cards (current vs previous for trends), earnings
// from subscription paidAmount, donut segments, profile completeness.
export const getDashboardStats = async (token, params) => {
  const uri = `/admin/api/v1/customers/dashboardStats`;
  const resp = await axios.get(authService + uri, {
    params,
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

// Paginated, searchable customer list for a donut segment
// (subscribed | inactive | other)
export const getSegmentCustomers = async (token, params) => {
  const uri = `/admin/api/v1/customers/segmentCustomers`;
  const resp = await axios.get(authService + uri, {
    params,
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const getAuthAnalytics = async (token, data) => {
  let uri = `/admin/api/customers/analytics/upgraded-after-may15`;

  const resp = await axios.post(authService + uri, data, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const getOpenAppStatRequest = async (token, data) => {
  let uri = `/admin/api//customers/analytics/app-open-may15`;

  const resp = await axios.post(authService + uri, data, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};




export const getAuthIncompleteAnalytics = async (token, data) => {
  let uri = `/admin/api/customers/analytics/partial-data-after-may15`;

  const resp = await axios.post(authService + uri, data, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};


export const findCustomerWithPhoneNumbers = async (token, payload) => {
  let uri = `/admin/api/v1/customers/findCustomerWithPhoneNumbers`;
  const resp = await axios.post(authService + uri, payload, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const changeCompApi = async (token, payload) => {
  let uri = `/admin/api/v1/contact/changeContactOwner`;
  const resp = await axios.post(authService + uri, payload, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const findCustomerWithPhone = async (token, payload) => {
  let uri = `/admin/api/v1/customers/findCustomersWithPhone`;
  const resp = await axios.post(authService + uri, payload, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const findCustomerOlderThanThreeDay = async (token, payload) => {
  let uri = `/admin/api/v1/customers/findCustomerOlderThanThreeDay`;
  const resp = await axios.post(authService + uri, payload, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const checkUserExitAgainstNumber = async (token, payload) => {
  let uri = `/admin/api/v1/subAdminTasks/checkUserExitAgainstNumber`;
  const resp = await axios.post(authService + uri, payload, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const AddCity = async (payload, token) => {
  const uri = "/admin/api/v1/cities/addCities";
  const resp = await axios.post(authService + uri, payload, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};
export const getAllAvailableCities = async (token) => {
  const uri = "/admin/api/v1/cities/getAllAvailableCities";
  const resp = await axios.get(
    authService + uri,

    {
      headers: {
        Authorization: "bearer " + token,
        "api-key": "poultrybaba@1234Sumandri",
      },
    },
  );
  return resp.data;
};
export const activeCityForCityRequest = async (id, data, token) => {
  const uri = `/admin/api/v1/cities/activeForProduct/${id}`;
  const resp = await axios.patch(authService + uri, data, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp;
};

export const deActiveCityForCityRequest = async (id, data, token) => {
  const uri = `/admin/api/v1/cities/inActiveForProduct/${id}`;
  const resp = await axios.patch(authService + uri, data, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp;
};
export const createAdminOrSubAdmin = async (
  { name, email, password, phoneNumber, city, type, permissions },
  token,
) => {
  const uri = "/admin/api/v1/admin/createAdminOrSubAdmin";
  const resp = await axios.post(
    authService + uri,
    { name, email, password, phoneNumber, city, type, permissions },
    {
      headers: {
        Authorization: "bearer " + token,
        "api-key": "poultrybaba@1234Sumandri",
      },
    },
  );
  return resp.data;
};
export const deleteUserByUserId = async ({ userId }, token) => {
  const uri = "/admin/api/v1/customers/deleteUserById?userId=" + userId;
  const resp = await axios.delete(authService + uri, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const activeORInActive = async ({ userId, blocked }, token) => {
  const uri = "/admin/api/v1/customers/blockOrUnBlockAdminUser";
  const resp = await axios.get(authService + uri, {
    params: {
      userId,
      blocked,
    },
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const editAdminUser = async (payload, token) => {
  const uri = "/admin/api/v1/admin/editAdminOrSubAdmin";
  const resp = await axios.patch(
    authService + uri,
    { ...payload },
    {
      headers: {
        Authorization: "bearer " + token,
        "api-key": "poultrybaba@1234Sumandri",
      },
    },
  );
  return resp.data;
};

export const feedBackGet = async ({ pageNo, feedbackResponsed }, token) => {
  const uri =
    "/admin/api/v1/pbFeedback/getFeedbacks?pageNo=" +
    pageNo +
    "&feedbackResponsed=" +
    feedbackResponsed;

  const resp = await axios.get(authService + uri, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const feedBackEdit = async ({ feedbackId, attributes }, token) => {
  const uri = "/admin/api/v1/pbFeedback/updateFeedback";
  const resp = await axios.post(
    authService + uri,
    { feedbackId, attributes },
    {
      headers: {
        Authorization: "bearer " + token,
        "api-key": "poultrybaba@1234Sumandri",
      },
    },
  );
  return resp.data;
};

export const getListOfMandiGurus = async (
  requestStatus = "PENDING",
  pageNo,
  token,
) => {
  const uri = "/admin/api/v1/mandigurus/getMandiGurusWithPagination";
  const resp = await axios.get(authService + uri, {
    params: {
      requestStatus,
      pageNo,
    },

    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const updateMandiGuruRequestStatus = async (
  { customerId, requestStatus },
  token,
) => {
  const uri = "/admin/api/v1/mandigurus/updateMandiGuruRequestStatus";
  const resp = await axios.post(
    authService + uri,
    {
      customerId,
      requestStatus,
    },
    {
      headers: {
        Authorization: "bearer " + token,
        "api-key": "poultrybaba@1234Sumandri",
      },
    },
  );
  return resp.data;
};

export const getUserCrmUser = async (params, token) => {
  const uri = `/admin/api/v1/stat/userCrmDailyUser`;
  const resp = await axios.get(authService + uri, {
    params: {
      ...params,
    },
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const getUserCrmDailyStat = async (params, token) => {
  const uri = `/admin/api/v1/stat/userCrmDailyStat`;
  const resp = await axios.get(authService + uri, {
    params: {
      ...params,
    },
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const getContactWithTask = async (params, token) => {
  const uri = "/admin/api/v1/subAdminTasks/getContacts";
  const resp = await axios.post(
    authService + uri,
    {},
    {
      params: {
        ...params,
      },
      headers: {
        Authorization: "bearer " + token,
        "api-key": "poultrybaba@1234Sumandri",
      },
    },
  );
  return resp.data;
};

export const AddTaskPhoneNumber = async (payload, token) => {
  const uri = "/admin/api/v1/subAdminTasks/createContacts";
  const resp = await axios.post(authService + uri, payload, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const updatePhoneStatusCrm = async (payload, token) => {
  const uri = "/admin/api/v1/subAdminTasks/updateContactStatus";
  const resp = await axios.post(authService + uri, payload, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const createTask = async (payload, token) => {
  const uri = "/admin/api/v1/subAdminTasks/createTask";
  const resp = await axios.post(authService + uri, payload, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const getTaskUserIdAndMonth = async ({ userId, month }, token) => {
  const uri = "/admin/api/v1/subAdminTasks/getTasks";
  const resp = await axios.post(
    authService + uri,
    {},
    {
      params: {
        userId,
        month,
      },
      headers: {
        Authorization: "bearer " + token,
        "api-key": "poultrybaba@1234Sumandri",
      },
    },
  );
  return resp.data;
};

export const getAdminAlerts = async ({ page }, token) => {
  const uri = "/admin/api/v1/adminAlert/getAdminAlert";
  const resp = await axios.get(
    authService + uri,

    {
      params: {
        page,
      },
      headers: {
        Authorization: "bearer " + token,
        "api-key": "poultrybaba@1234Sumandri",
      },
    },
  );
  return resp.data;
};

export const createNotification = async (data, token, setLoading) => {
  let { version, message, title, appLink, occupationTypes, businessNatures } = data;
  try {
    setLoading(true);
    const uri = "/admin/api/v1/customers/broadcastNotification";
    const resp = await axios.post(
      authService + uri,
      { notificationType: version, message, title, appLink, occupationTypes, businessNatures },
      {
        headers: {
          Authorization: "bearer " + token,
          "api-key": "poultrybaba@1234Sumandri",
        },
      },
    );
    setLoading(false);
    messageAlert.success("Notification is successfully sended");
    return resp.data;
  } catch (error) {
    messageAlert.error("We can't process your resquest please try again later");
    setLoading(false);
  }
};

export const createNotificationAdminAlert = async (
  data,
  token,
  setLoading,
) => {
  // Forward the FULL payload — the previous implementation destructured only
  // {message, title, sentTime} and silently dropped `runDaily` / `active`,
  // which is why the Run Daily toggle did nothing on create.
  const {
    message,
    title,
    sentTime,
    runDaily = false,
    active = true,
    topic,
    occupationTypes = [],
    businessNatures = [],
  } = data || {};

  try {
    if (typeof setLoading === "function") setLoading(true);
    const uri = "/admin/api/v1/adminAlert/createNotification";
    const resp = await axios.post(
      authService + uri,
      { message, title, sentTime, runDaily, active, occupationTypes, businessNatures, ...(topic ? { topic } : {}) },
      {
        headers: {
          Authorization: "bearer " + token,
          "api-key": "poultrybaba@1234Sumandri",
        },
      },
    );
    if (typeof setLoading === "function") setLoading(false);
    messageAlert.success("Notification scheduled successfully");
    return resp.data;
  } catch (error) {
    console.log(error);
    messageAlert.error(
      error?.response?.data?.error ||
      "We couldn't schedule this notification — please try again"
    );
    if (typeof setLoading === "function") setLoading(false);
    throw error;
  }
};

export const updateNotificationAdminAlert = async (
  data,
  token,
  setLoading,
) => {
  try {
    if (typeof setLoading === "function") setLoading(true);
    const uri = "/admin/api/v1/adminAlert/updateNotification";
    const resp = await axios.post(
      authService + uri,
      { ...data },
      {
        headers: {
          Authorization: "bearer " + token,
          "api-key": "poultrybaba@1234Sumandri",
        },
      },
    );
    if (typeof setLoading === "function") setLoading(false);
    messageAlert.success("Notification updated successfully");
    return resp.data;
  } catch (error) {
    console.log(error);
    messageAlert.error(
      error?.response?.data?.error ||
      "We couldn't update this notification — please try again"
    );
    if (typeof setLoading === "function") setLoading(false);
    throw error;
  }
};

export const deleteNotificationAdminAlert = async (
  notificationId,
  token,
  setLoading,
) => {
  try {
    if (typeof setLoading === "function") setLoading(true);
    const uri = `/admin/api/v1/adminAlert/deleteNotification/${notificationId}`;
    const resp = await axios.delete(authService + uri, {
      headers: {
        Authorization: "bearer " + token,
        "api-key": "poultrybaba@1234Sumandri",
      },
    });
    if (typeof setLoading === "function") setLoading(false);
    messageAlert.success("Notification deleted");
    return resp.data;
  } catch (error) {
    console.log(error);
    messageAlert.error(
      error?.response?.data?.error ||
      "We couldn't delete this notification — please try again"
    );
    if (typeof setLoading === "function") setLoading(false);
    throw error;
  }
};





// Scheduler health — surfaces whether the Bull/Redis notification queue is
// actually up. This endpoint has existed on the backend for a while
// (auth-service returns 503 when Redis/the safety-net sweep is down) but
// nothing in the admin panel called it, so an admin could hit "Schedule"
// successfully while the queue was silently unable to fire anything. No
// `messageAlert` here — this is polled in the background, not a user action,
// so the caller decides how (or whether) to surface a failure.
export const getSchedulerHealthAdminAlert = async (token) => {
  const uri = "/admin/api/v1/adminAlert/schedulerHealth";
  const resp = await axios.get(authService + uri, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
    // A 503 from the backend is the expected "unhealthy" shape, not an
    // exception we want axios to throw on — it still carries the full
    // health JSON body we want to render.
    validateStatus: () => true,
  });
  return resp.data;
};

export const cityWiseCount = async (payload, token) => {
  const uri = "/api/v1/franchise/stat/city-wise-count";
  const resp = await axios.get(authService + uri, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const getNotificationsAdminAlert = async (payload, token) => {
  const uri = "/admin/api/v1/adminAlert/getNotfications";

  // Serialise Date / moment values explicitly — axios would stringify a raw
  // Date via toString() (ctime), which the backend's moment(today) parser
  // can't read reliably. Also drop undefined/null so empty filters really
  // mean "no filter" on the backend.
  const params = {};
  Object.entries(payload || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    if (v instanceof Date) {
      params[k] = v.toISOString();
    } else if (v && typeof v.toISOString === "function") {
      params[k] = v.toISOString();
    } else {
      params[k] = v;
    }
  });

  const resp = await axios.get(authService + uri, {
    params,
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const addNote = async (payload, token) => {
  // Agar authService mein /admin shamil nahi hai to yahan add karein
  const uri = "/admin/api/v1/notes/addNote";
  const resp = await axios.post(authService + uri, payload, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

export const getNotes = async (customerId, token) => {
  const uri = `/admin/api/v1/notes/getNotes?customerId=${customerId}`;
  const resp = await axios.get(authService + uri, {
    headers: {
      Authorization: "bearer " + token,
      "api-key": "poultrybaba@1234Sumandri",
    },
  });
  return resp.data;
};

